export default "__VITE_ASSET__D643nX2T__"